import { useTranslation } from "react-i18next";
import { useEffect, useState, useRef, memo } from 'react';
import '../../styles/game/InfoBoard.css';
import '../../styles/game/InfoBoardTabs.css';
import '../../styles/game/InfoBoardComponents.css';
import { t } from "i18next";
import { useData, useSocket } from '../../providers/SocketContext.jsx'
import { useAuth } from '../../providers/AuthProvider.jsx';
import AllBetsTitle from "./AllBetsTitle";
import RealTimeBetsComponent from "./RealTimeBetsComponent";
function AllBets({ isPreviousRound, setIsPreviousRound }) {
    const { user } = useAuth()
    const socket = useSocket()
    // const [allBets, setAllBets] = useState({})
    // const [singlePlayersCount, setSinglePlayersCount] = useState("")
    // const [doublePlayersCount, setDoublePlayersCount] = useState("")
    // const [totalPlayersCount, setTotalPlayersCount] = useState("")
    // const [isPreviousRound, setIsPreviousRound] = useState(false)
    const [isViewBets, setIsViewBets] = useState(null);
    const [multiplierData, setMultiplierData] = useState(null);
    const [isMultiplier, setIsMultiplier] = useState(null)

    const [mainWallet, setMainWallet] = useState('uzs')
    const [usdToUzsRate, setUsdToUzsRate] = useState(13000)

    const totalWinRef = useRef(0)
    const [totalWin, setTotalWin] = useState(totalWinRef.current)
    const [totalBets, setTotalBets] = useState(0);

    useEffect(() => {
      if(!socket) {
        return
      }


      socket.on('connect', () => {
        console.log('connection' + socket.id)
      })


      return () => {
        socket.off('connect')
      }
      
    }, [socket])

    useEffect(() => {
      if(user) {
        setMainWallet(user.mainWallet)
      }
    }, [user])

    // useEffect(() => {
    //   if(!socket) {
    //     return
    //   }
    //   const handleAllBetsList = (res, sendBets) => {
    //     const sendBetsArr = []
    //     for (const bet in sendBets) {
    //       sendBetsArr.push(sendBets[bet])
    //     }
    //     const combinedBets = [...res, ...sendBetsArr]

    //     // const sortedBets = sortByBetAscending(combinedBets)
    //     combinedBets.sort((a, b) => parseFloat(b.bet) - parseFloat(a.bet));
    //     // console.log("Received bets:", sortedBets);
    //     setAllBets(combinedBets);
    //   };

    //   socket.emit('connectAllbets')
    //   socket.on('connectAllbets_res', handleAllBetsList)
      
    //   return () => {
    //     socket.off("connectAllbets_res");
    //     socket.off('connectAllbets')
    //   };

    // }, [socket])

    // useEffect(() => {
    //   if (!socket) {
    //     return;
    //   }
  
    //   const handleTotalBetPlayers = (singlePlayers, doublePlayers, totalPlayers) => {
    //     console.log('Single players:', singlePlayers, 'Double players:', doublePlayers);
    //     setSinglePlayersCount(parseFloat(singlePlayers));
    //     setDoublePlayersCount(parseFloat(doublePlayers));
    //     setTotalPlayersCount(parseFloat(totalPlayers));
    //   };
  
    //   socket.on('get_total_bet_players', handleTotalBetPlayers);
  
    //   return () => {
    //     socket.off('get_total_bet_players', handleTotalBetPlayers);
    //   };
    // }, [socket]);

    // useEffect(() => {
    //   if(!socket) {
    //     return
    //   }

    //   socket.emit('getSingleDouble')
    //   socket.on('SingleDouble', (obj) => {
        
    //     setSinglePlayersCount(parseFloat(obj.singlePlayers));
    //     setDoublePlayersCount(parseFloat(obj.doublePlayers));
    //   })

    //   return () => {
    //     socket.off('SingleDouble', (obj) => {
    //       setSinglePlayersCount(parseFloat(obj.singlePlayers));
    //       setDoublePlayersCount(parseFloat(obj.doublePlayers));
    //     })
    //   }
    // }, [socket])

    // useEffect(() => {
    //   if(!socket) {
    //     return
    //   }

    //   socket.on('single_double_players_update', (res) => {
    //     setSinglePlayersCount(res.singlePlayers)
    //     setDoublePlayersCount(res.doublePlayers)
    //   })

    //   return () => {
    //     socket.off('single_double_players_update', (res) => {
    //       setSinglePlayersCount(res.singlePlayers)
    //       setDoublePlayersCount(res.doublePlayers)
    //     })
    //   }
    // }, [socket])


    const sortByBetAscending = (obj) => {
      // Преобразуем объект в массив
      const entries = Object.entries(obj);
    
      // Сортируем массив по возрастанию значения bet
      const sortedEntries = entries.sort(
        ([, a], [, b]) => parseFloat(b.bet) - parseFloat(a.bet)
      );
    
      // Создаем новый объект из отсортированного массива
      const sortedObject = {};
      sortedEntries.forEach(([key, value]) => {
        sortedObject[key] = value;
      });
    
      return sortedObject;
    };



    function AllBetsComponent() {




      return (
        <>
            <div className={'all-bets-tab'}>
                <div className={'all-bets-header-wrapper'}>
                    <AllBetsTitle />
                    <div className={'all-bets-legend'}>
                        <span className={'all-bets-user'}>{t("all_bets_player")}</span>
                        <span className={'all-bets-bet'}>{t("bet")} {mainWallet ? mainWallet.toUpperCase() : ""}</span>
                        <span className={'all-bets-x'}>X</span>
                        <span className={'all-bets-cashout'}>{t("win")} {mainWallet ? mainWallet.toUpperCase() : ""}</span>
                    </div>

                </div>
                <RealTimeBetsComponent mainWallet={mainWallet} />

            </div>
        </>
      )
    }



    function PreviousReal({bet, celebrated, aviatorId, avatarUrl, cashout, profit}) {
      const [color, setColor] = useState("rgb(52, 180, 255)");

      useEffect(() => {
        const parseCashout = parseFloat(cashout)
        if (parseCashout >= 2.00 && parseCashout < 10.00) {
          setColor("rgb(145, 62, 248)")
        } else if (parseCashout >= 10.00) {
          setColor("rgb(192, 23, 180)")
        }
        
          if(parseResultData >= parseCashout) {
            setIsCashout(true)
          
        }
        
      }, [])

      return (
          <>
              <div className={`my-bet-item-wrap new ${cashout ? "celebrated" : ""}`}>
                  <div className={'all-bets-user-wrap'}>
                      <img src={avatarUrl} alt="" />
                      <div>{aviatorId ? `${aviatorId[0]}***${aviatorId[7]}` : ""}</div>
                  </div>
                  <div className={'my-bet-item-bet new'}>
                      <div>{bet ? bet : ""}</div>
                  </div>
                  <div className={'my-bet-item-multiplier new'}>
                      <div>
                          {cashout && <div style={{color}} className={`bubble-multiplier new`}>{cashout ? cashout + "x" : ""}</div>}
                      </div>
                  </div>
                  <div className={'my-bet-item-cash-out new'}>
                      {cashout ? <div>{profit}</div> : ""}
                  </div>
              </div>
          </>
      )
  }

  function PreviousAnother({isPreviousRoundResult, bet, aviatorId, avatarUrl, cashout, profit, mainWallet}) {
    const [isCashout, setIsCashout] = useState(false)
    const [color, setColor] = useState("rgb(52, 180, 255)");
    const [currencyRate, setCurrencyRate] = useState(null)
      useEffect(() => {
        if(mainWallet) {
          if(mainWallet === 'uzs') {
            setCurrencyRate(13000)
          } else if (mainWallet === 'usd') {
            setCurrencyRate(1)
          } else if (mainWallet === 'rub') {
            setCurrencyRate(100)
          } else {
            setCurrencyRate(1)
          }
          
        }
      }, [mainWallet])
    useEffect(() => {
      const parseResultData = parseFloat(isPreviousRoundResult)
      const parseCashout = parseFloat(cashout)
      if (parseCashout >= 2.00 && parseCashout < 10.00) {
        setColor("rgb(145, 62, 248)")
      } else if (parseCashout >= 10.00) {
        setColor("rgb(192, 23, 180)")
      }
      
        if(parseResultData >= parseCashout) {
          setIsCashout(true)
        
      }
      
    }, [isPreviousRoundResult])

    return (
    <>
    <div className={`my-bet-item-wrap new  ${isCashout ? "celebrated" : ""}`}>
        <div className={'all-bets-user-wrap'}>
            <img src={avatarUrl} alt="" />
            <div>{aviatorId ? aviatorId : ""}</div>
        </div>
        <div className={'my-bet-item-bet new'}>
            <div>{bet ? new Intl.NumberFormat('en-US', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(bet * currencyRate) : ""}</div>
        </div>
        <div className={'my-bet-item-multiplier new'}>
            <div>
                {isCashout && <div style={{color}} className={`bubble-multiplier new`}>{cashout ? parseFloat(cashout).toFixed(2) + "x" : ""}</div>}
            </div>
        </div>
        <div className={'my-bet-item-cash-out new'}>
            {isCashout ? <div>{new Intl.NumberFormat('en-US', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(profit * currencyRate)}</div> : "0.00"}
        </div>
    </div>
</>
)
  }





    function PreviousRoundComponent() {

      const [isPreviousRoundResult, setIsPreviousRoundResult] = useState(null)
      const [isPreviousRoundHistory, setIsPreviousRoundHistory] = useState(null)
      const [isPreviousRoundAnother, setIsPreviousRoundAnother] = useState(null)
      const [sortedBets, setSortedBets] = useState({});
      const [color, setColor] = useState("rgb(52, 180, 255)");
      useEffect(() => {
        if(!socket) {
          return
        }


        socket.emit('previousRound')
      }, [socket])

      useEffect(()=> {
        if(!socket) {
          return
        }

        socket.on('previousRoundData', (res) => {

          const sendBetsArr = []
          for (const bet in res.previousRoundAnother) {
            sendBetsArr.push(res.previousRoundAnother[bet])
          }
          const combinedBets = [...res.previousRoundHistory, ...sendBetsArr]
          combinedBets.sort((a, b) => parseFloat(b.bet) - parseFloat(a.bet));
          setIsPreviousRoundResult(res.previousRoundResult)
          // const previousCombined = {...res.previousRoundHistory, ...res.previousRoundAnother}
          // const previousSorted = sortByBetAscending(previousCombined)
          
          setSortedBets(combinedBets)

        })

        return () => {
          socket.off('previousRoundData');
        };
      }, [socket])

      useEffect(() => {
        const parseCashout = isPreviousRoundResult ? parseFloat(isPreviousRoundResult) : 1.00;
        if (parseCashout >= 2.00 && parseCashout < 10.00) {
          setColor("rgb(145, 62, 248)")
        } else if (parseCashout >= 10.00) {
          setColor("rgb(192, 23, 180)")
        }
      }, [isPreviousRoundResult])

      return (
        <>
        <div className={'all-bets-tab'}>
            <div className={'all-bets-header-wrapper'}>
              <div className={'previous-round-result-title-wrap'}>
                <div className={'previous-round-result-text'}>{t("roundResult")}</div>
                <div className={'previous-round-result-multiplier'}>
                {isPreviousRoundResult && <div style={{color}}>{isPreviousRoundResult ? parseFloat(isPreviousRoundResult).toFixed(2) + "x" : ""}</div>}
                </div>
              </div>
                {/* <div className={'all-bets-block'}>
                    <div>
                        <div>{t("AllBets").toUpperCase()}</div>
                        <span>{sortedBets ? Object.entries(sortedBets).length : 0}</span>
                    </div>
                    <div className={'my-bet-item-multiplier new'}>
                        <div>
                            {isPreviousRoundResult && <div style={{color}} className={`bubble-multiplier`}>{isPreviousRoundResult ? parseFloat(isPreviousRoundResult).toFixed(2) + "x" : ""}</div>}
                        </div>
                    </div>
                    <div className={'previous-hand prev'} onClick={() => setIsPreviousRound(false)}>
                        <div className={'previous-history-icon-prev'}></div>
                        <span className={'previous-text'}>{t("PreviousRound")}</span>
                    </div>
                </div> */}
                {/* <div className={'all-bets-spacer'}></div> */}
                <div className={'all-bets-legend'}>
                    <span className={'all-bets-user'}>{t("all_bets_player")}</span>
                    <span className={'all-bets-bet'}>{t("bet")} {mainWallet ? mainWallet.toUpperCase() : ""}</span>
                    <span className={'all-bets-x'}>X</span>
                    <span className={'all-bets-cashout'}>{t("win")} {mainWallet ? mainWallet.toUpperCase() : ""}</span>
                </div>
  
            </div>
            <div className={'real-time-bets-wrapper'}>
                <div className={'real-time-bets-container'}>
                {Object.keys(sortedBets).length > 0 ? (
            <>
              {Object.entries(sortedBets).map(([key, bet]) => (
                bet.hasOwnProperty('another') ? (
                <PreviousAnother
                  key={key}
                  isPreviousRoundResult={isPreviousRoundResult}
                  bet={bet.bet}
                  avatarUrl={bet.avatarUrl}
                  aviatorId={bet.aviatorId}
                  cashout={bet.cashout}
                  profit={bet.profit}
                  mainWallet={mainWallet}
                />
                 ) : (
                      // <RealTimeBetsComponent
                      //   key={key}
                      //   bet={bet.bet}
                      //   avatarUrl={bet.avatarUrl}
                      //   aviatorId={bet.aviatorId}
                      //   cashout={bet.cashout}
                      //   profit={bet.profit}
                      //   mainWallet={mainWallet}
                      // />
                      <></>
                    )
            ))}
            </>
          ) : (
            ""
          )}

  
  
                </div>
            </div>
        </div>
    </>
      )
    }






    return (
        <>
          {isPreviousRound ? <PreviousRoundComponent/> : <AllBetsComponent />}
        </>
    )
}

export default AllBets;